import { DRAWINGMODE, LAYOUT } from '@/constants';
import { useActions } from '@/store/useStore';
import eventbus from 'tiny-emitter/instance';

export const allowCtrlA = (obj) => {
  const handleKeyDown = (e) => {
    if (document.activeElement && document.activeElement !== document.body) return;
    const isCommandKeyPressed = e.metaKey || e.ctrlKey;
    if (e.key === 'a' && isCommandKeyPressed) {
      e.preventDefault();
      obj.app.seatmap.selectAllUnits();
    }
  };

  document.addEventListener('keydown', handleKeyDown);

  const originalDestroy = obj.destroy;
  obj.destroy = () => {
    document.removeEventListener('keydown', handleKeyDown);
    originalDestroy.call(obj);
  };
};

export const allowEsc = (obj) => {
  const actions = useActions('settings');

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      if (obj.app.layout === LAYOUT.INSIDESECTION) {
        if (obj.app.seatmap.selection.items.length) {
          obj.app.seatmap.clearSelection();
        } else {
          actions.setDrawingMode();
          actions.setZonesLayout();
          eventbus.emit('seatmap:labels:updated');
          actions.changeDrawingMode(DRAWINGMODE.MAIN);
          actions.enableSelection();
          eventbus.emit('seatmap:exitZone:after');
        }
      } else {
        obj.app.seatmap.clearSelection();
      }
    }
  };

  document.addEventListener('keydown', handleKeyDown);

  const originalDestroy = obj.destroy;
  obj.destroy = () => {
    document.removeEventListener('keydown', handleKeyDown);
    originalDestroy.call(obj);
  };
};
